














import {Component, Prop, Vue} from 'vue-property-decorator';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
})
export default class PlanResByShiftPlywoodBalance extends Vue {
    @Prop() params!: any;
    @Prop() tabData!: any;

    get idPlanRes() {
        return this.tabData?.idPlanRes;
    }

    get shiftIndex() {
        let value = this.params?.requestParams?.find((item: any) => item.key === 'shiftIndex')?.value;
        return value !== undefined && value !== -1 ? value : this.tabData?.shiftIndex;
    }

    get api() {
        return this.params.api ? this.params.api : this.$api.journals.planResByShiftPlywoodBalance;
    }

    get idGridConfigItem() {
        return this.params?.requestParams?.find((item: any) => item.key === 'idGridConfigItem')?.value;
    }
}
